import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CheckAuth } from '../../../Services/utility.service';
import { ToolEnum } from '../../../Models/Common';
import { DashboardCountService } from 'src/Services/dashboardCount.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  tokenKey: string = '';

  ///Admin Dashboard
  totalCompanies: number = 0;
  totalSubscribers: number = 0;
  totalAdmins: number = 0;
  totalMenus: number = 0;

  ///jsi360 Dashboard
  totalStateCommission: number = 0;
  totalCarrier: number = 0;
  totalBriefing: number = 0;
  total477Data: number = 0;
  totalWebinar: number = 0;
  totalWhitePapers: number = 0;
  totalBanner: number = 0;
  totalSeminar: number = 0;
  totalGeneralAlerts: number = 0;
  totalTraining: number = 0;
  totalSpecialReports: number = 0;
  totalTaxExemptionForm: number = 0;
  totalSpecialReportsSections: number = 0;
  totalTrs: number = 0;
  totalInteserraResources: number = 0;

  ///Briefings Dashboard
  totalBriefings: number = 0;
  totalBriefingType: number = 0;
  totalBriefingSubType: number = 0;
  totalBriefingchecklist: number = 0;
  totalChecklist: number = 0;

  ///IPR Dashboard
  totalIprupdates: number = 0;
  totalIprAlerts = 0;

  ///RMD Dashboard
  totalRmdAlerts = 0;
  totalRmdupdates: number = 0;

  ///Trac-IT Dashboard
  totalTracItEntries: number = 0;
  totalCategories: number = 0;
  totalCarrierTypes: number = 0;
  totalTracItUpdates: number = 0;
  totalTracItAlerts: number = 0;

  ///VoIP Dashboard
  totalVoIPStates: number = 0;
  totalVoIPUpdates: number = 0;
  totalVoIPAlerts: number = 0;
  totalVoIPActivesubscribers: number = 0;

  ///IPCS Dashboard
  totalIpcsStates: number = 0;
  totalIpcsUpdates: number = 0;
  totalIpcsAlerts: number = 0;
  totalIpcsActivesubscribers: number = 0;

  ///Wireless  Dashboard
  totalWirelessStates: number = 0;
  totalWirelessUpdates: number = 0;
  totalWirelessAlerts: number = 0;
  totalWirelessActivesubscribers: number = 0;

  ///911  Dashboard
  total911States: number = 0;
  total911County: number = 0;
  total911City: number = 0;
  total911Rate: number = 0;
  total911Contacts: number = 0;
  total911Updates: number = 0;
  total911Alerts: number = 0;

  ///TRFA  Dashboard
  totalTrfaJurisdictions: number = 0;
  totalTrfaCarriers: number = 0;
  totalTrfaCategorys: number = 0;
  totalTrfaFundTypes: number = 0;
  totalTrfaFunds: number = 0;
  totalTrfaContents: number = 0;
  totalTrfaLinks: number = 0;
  totalTrfaCompareView: number = 0;
  totalTrfaSource: number = 0;
  totalTrfaAudit: number = 0;
  totalTrfaUpdates: number = 0;
  totalTrfaAlerts: number = 0;

  ///CRRA  Dashboard
  totalCrraJurisdictions: number = 0;
  totalCrraCarriers: number = 0;
  totalCrraCategories: number = 0;
  totalCrraSubCategories: number = 0;
  totalCrraDepositRates: number = 0;
  totalCrraContents: number = 0;
  totalCrraLinks: number = 0;
  totalCrraAudit: number = 0;
  totalCrraUpdates: number = 0;
  totalCrraAlerts: number = 0;

  ///View 47 Dashboard
  totalView47Carriers: number = 0;
  totalView47Category: number = 0;
  totalView47Contents: number = 0;
  totalView47Updates: number = 0;
  totalView47Pending: number = 0;
  totalView47Internal: number = 0;
  totalView47Delete: number = 0;

  ///Price Quote Dashboard
  totalBaseRateType: number = 0;
  totalBaseRate: number = 0;
  totalMiscFee: number = 0;
  totalCompanyProfile: number = 0;
  totalPriceQuotes: number = 0
  totalOnboarding: number = 0

  SelectedTool: string;
  productId: number = 1;
  isUserSystemAdmin: boolean = false;

  constructor(
    private readonly titleService: Title,
    private readonly dashboardCountService: DashboardCountService,
    private readonly checkAuth: CheckAuth,
    private sessionStorageService: SessionStorageService
  ) {

    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Dashboard');
  }

  ngOnInit() {
    if (this.SelectedTool == 'Admin') {
      this.isUserSystemAdmin = true;
      this.GetAdminDashboardCount();
    }
    else if (this.productId == ToolEnum.jsi360) {
      this.GetJsi360DashboardCount();
    }
    else if (this.productId == ToolEnum.briefingServices) {
      this.GetBriefingDashboardCount();
    }
    else if (this.productId == ToolEnum.ipr) {
      this.GetIPRDashboardCount();
    }
    else if (this.SelectedTool == 'rmd') {
      this.GetRMDDashboardCount();
    }
    else if (this.productId == ToolEnum.actionitem) {
      this.GetTracItDashboardCount();
    }
    else if (this.productId == ToolEnum.voip) {
      this.GetVoIPDashboardCount();
    }
    else if (this.productId == ToolEnum.ipcs) {
      this.GetIPCSDashboardCount();
    }
    else if (this.productId == ToolEnum.wireless) {
      this.GetWirelessDashboardCount();
    }
    else if (this.SelectedTool == '911') {
      this.Get911DashboardCount();
    }
    else if (this.SelectedTool == 'trfa') {
      this.GetTRFADashboardCount();
    }
    else if (this.SelectedTool == 'crra') {
      this.GetCRRADashboardCount();
    }
    else if (this.SelectedTool == 'view 47') {
      this.GetView47DashboardCount();
    }
    else if (this.SelectedTool == 'PricingQuote') {
      this.GetPriceQuoteDashboardCount();
    }
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetAdminDashboardCount() {
    if (this.tokenKey != null) {
      this.dashboardCountService.GetAdminDashboardcount(this.tokenKey).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.totalCompanies = data['recordCount'][0]["totalCompany"];
            this.totalSubscribers = data['recordCount'][0]["totalSubscribers"];
            this.totalAdmins = data['recordCount'][0]["totalAdmins"];
            this.totalMenus = data['recordCount'][0]["totalMenus"];
          }
        },
        error => {
          console.log('Admin Dashboard count :' + error)
        }
      );
    }
  }

  GetJsi360DashboardCount() {
    this.dashboardCountService.GetJsi360DashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.totalStateCommission = data['recordCount'][0]["totalStateCommission"];
          this.totalCarrier = data['recordCount'][0]["totalCarrier"];
          this.totalBriefing = data['recordCount'][0]["totalBriefing"];
          this.total477Data = data['recordCount'][0]["total477Data"];
          this.totalWebinar = data['recordCount'][0]["totalWebinar"];
          this.totalWhitePapers = data['recordCount'][0]["totalWhitePapers"];
          this.totalBanner = data['recordCount'][0]["totalBanner"];
          this.totalSeminar = data['recordCount'][0]["totalSeminar"];
          this.totalGeneralAlerts = data['recordCount'][0]["totalGeneralAlerts"];
          this.totalTraining = data['recordCount'][0]["totalTraining"];
          this.totalSpecialReports = data['recordCount'][0]["totalSpecialReports"];
          this.totalTaxExemptionForm = data['recordCount'][0]["totalTaxExemptionForm"];
          this.totalSpecialReportsSections = data['recordCount'][0]["totalSpecialReportsSections"];
          this.totalTrs = data['recordCount'][0]["totalTrs"];
          this.totalInteserraResources = data['recordCount'][0]["totalInteserraResources"];
        }
      }, error => {
        console.log('i360 Dashboard count :' + error)
      }
    );
  }

    GetBriefingDashboardCount() {
    this.dashboardCountService.GetBriefingDashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.totalBriefings = data['recordCount'][0]["totalBriefing"];
          this.totalBriefingType = data['recordCount'][0]["totalBriefingType"];
          this.totalBriefingSubType = data['recordCount'][0]["totalBriefingSubType"];
          this.totalBriefingchecklist = data['recordCount'][0]["totalBriefingchecklist"];
          this.totalChecklist = data['recordCount'][0]["totalChecklist"];
        }
      }, error => {
        console.log('Briefing Dashboard count :' + error)
      }
    );
  }

  GetIPRDashboardCount() {
    if (this.tokenKey != null) {
      this.dashboardCountService.GetIPRDashboardCount(this.tokenKey).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.totalIprAlerts = data['recordCount'][0]["totalAlert"];
            this.totalIprupdates = data['recordCount'][0]["totalUpdate"];
          }
        },
        error => {
          console.log('IPR Dashboard count :' + error);
        }
      );
    }
  }

  GetRMDDashboardCount() {
    if (this.tokenKey != null) {
      this.dashboardCountService.GetRMDDashboardCount(this.tokenKey).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.totalRmdAlerts = data['recordCount'][0]["totalAlert"];
            this.totalRmdupdates = data['recordCount'][0]["totalUpdate"];
          }
        },
        error => {
          console.log('RMD Dashboard count :' + error);
        }
      );
    }
  }

  GetTracItDashboardCount() {
    this.dashboardCountService.GetTracITDashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.totalTracItEntries = data['recordCount'][0]["totalTracItEntries"];
          this.totalCategories = data['recordCount'][0]["totalCategories"];
          this.totalCarrierTypes = data['recordCount'][0]["totalCarrierTypes"];
          this.totalTracItUpdates = data['recordCount'][0]["totalTracItUpdates"];
          this.totalTracItAlerts = data['recordCount'][0]["totalTracItAlerts"];
        }
      }, error => {
        console.log('TracIT Dashboard count :' + error);
      }
    );
  }

  GetVoIPDashboardCount() {
    this.dashboardCountService.GetVoIPDashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.totalVoIPStates = data['recordCount'][0]["totalVoIPStates"];
          this.totalVoIPUpdates = data['recordCount'][0]["totalVoIPUpdates"];
          this.totalVoIPAlerts = data['recordCount'][0]["totalVoIPAlerts"];
          this.totalVoIPActivesubscribers = data['recordCount'][0]["totalVoIPActivesubscribers"];
        }
      },
      error => {
        console.log('VoIP Dashboard count :' + error);
      }
    );
  }

  GetIPCSDashboardCount() {
    if (this.tokenKey != null) {
      this.dashboardCountService.GetIPCSDashboardCount(this.tokenKey).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.totalIpcsStates = data['recordCount'][0]["totalIpcsStates"];
            this.totalIpcsUpdates = data['recordCount'][0]["totalIpcsUpdates"];
            this.totalIpcsAlerts = data['recordCount'][0]["totalIpcsAlerts"];
            this.totalIpcsActivesubscribers = data['recordCount'][0]["totalIpcsActivesubscribers"];
          }
        },
        error => {
          console.log('IPCS Dashboard count :' + error);
        }
      );
    }
  }

  GetWirelessDashboardCount() {
    this.dashboardCountService.GetWirelessDashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.totalWirelessStates = data['recordCount'][0]["totalWirelessStates"];
          this.totalWirelessUpdates = data['recordCount'][0]["totalWirelessUpdates"];
          this.totalWirelessAlerts = data['recordCount'][0]["totalWirelessAlerts"];
          this.totalWirelessActivesubscribers = data['recordCount'][0]["totalWirelessActivesubscribers"];
        }
      },
      error => {
        console.log('Wireless Dashboard count :' + error);
      }
    );
  }

  Get911DashboardCount() {
    this.dashboardCountService.Get911DashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.total911States = data['recordCount'][0]["total911States"];
          this.total911County = data['recordCount'][0]["total911County"];
          this.total911City = data['recordCount'][0]["total911City"];
          this.total911Rate = data['recordCount'][0]["total911Rate"];
          this.total911Contacts = data['recordCount'][0]["total911Contacts"];
          this.total911Updates = data['recordCount'][0]["total911Updates"];
          this.total911Alerts = data['recordCount'][0]["total911Alerts"];
        }
      },
      error => {
        console.log('911 Dashboard count :' + error);
      }
    );
  }

  GetTRFADashboardCount() {
    this.dashboardCountService.GetTRFADashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.totalTrfaJurisdictions = data['recordCount'][0]["totalTrfaJurisdictions"];
          this.totalTrfaCarriers = data['recordCount'][0]["totalTrfaCarriers"];
          this.totalTrfaCategorys = data['recordCount'][0]["totalTrfaCategorys"];
          this.totalTrfaFundTypes = data['recordCount'][0]["totalTrfaFundTypes"];
          this.totalTrfaFunds = data['recordCount'][0]["totalTrfaFunds"];
          this.totalTrfaContents = data['recordCount'][0]["totalTrfaContents"];
          this.totalTrfaLinks = data['recordCount'][0]["totalTrfaLinks"];
          this.totalTrfaCompareView = data['recordCount'][0]["totalTrfaCompareView"];
          this.totalTrfaSource = data['recordCount'][0]["totalTrfaSource"];
          this.totalTrfaAudit = data['recordCount'][0]["totalTrfaAudit"];
          this.totalTrfaUpdates = data['recordCount'][0]["totalTrfaUpdates"];
          this.totalTrfaAlerts = data['recordCount'][0]["totalTrfaAlerts"];
        }
      },
      error => {
        console.log('TRFA Dashboard count :' + error);
      }
    );
  }

  GetCRRADashboardCount() {
    this.dashboardCountService.GetCRRADashboardCount(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.totalCrraJurisdictions = data['recordCount'][0]["totalCrraJurisdictions"];
          this.totalCrraCarriers = data['recordCount'][0]["totalCrraCarriers"];
          this.totalCrraCategories = data['recordCount'][0]["totalCrraCategories"];
          this.totalCrraSubCategories = data['recordCount'][0]["totalCrraSubCategories"];
          this.totalCrraDepositRates = data['recordCount'][0]["totalCrraDepositRates"];
          this.totalCrraContents = data['recordCount'][0]["totalCrraContents"];
          this.totalCrraLinks = data['recordCount'][0]["totalCrraLinks"];
          this.totalCrraAudit = data['recordCount'][0]["totalCrraAudit"];
          this.totalCrraUpdates = data['recordCount'][0]["totalCrraUpdates"];
          this.totalCrraAlerts = data['recordCount'][0]["totalCrraAlerts"];
        }
      },
      error => {
        console.log('CRRA Dashboard count :' + error);
      }
    );
  }

  GetView47DashboardCount() {
    this.dashboardCountService.GetView47DashboardCount(this.tokenKey).subscribe(
      data => {
        if (data.status == "Success") {
          this.totalView47Carriers = data['recordCount'][0]["totalView47Carriers"];
          this.totalView47Category = data['recordCount'][0]["totalView47Category"];
          this.totalView47Contents = data['recordCount'][0]["totalView47Contents"];
          this.totalView47Updates = data['recordCount'][0]["totalView47Updates"];
          this.totalView47Pending = data['recordCount'][0]["totalView47Pending"];
          this.totalView47Internal = data['recordCount'][0]["totalView47Internal"];
          this.totalView47Delete = data['recordCount'][0]["totalView47Delete"];
        }
      },
      error => {
        console.log('View47 Dashboard count :' + error);
      }
    );
  }

  GetPriceQuoteDashboardCount() {
    this.dashboardCountService.GetPriceQuoteDashboardCount(this.tokenKey).subscribe(
      data => {
        if (data.status == "Success") {
          this.totalBaseRateType = data['recordCount'][0]["totalBaseRateType"];
          this.totalBaseRate = data['recordCount'][0]["totalBaseRate"];
          this.totalMiscFee = data['recordCount'][0]["totalMiscFee"];
          this.totalCompanyProfile = data['recordCount'][0]["totalCompanyProfile"];
          this.totalPriceQuotes = data['recordCount'][0]["totalPriceQuotes"];
          this.totalOnboarding = data['recordCount'][0]["totalOnboarding"];
        }
      },
      error => {
        console.log('Price Quote Dashboard count :' + error);
      }
    );
  }
}
